import { getMessages } from './../../../../../../../store/constants';
export const DELETE_BUTTON_TITLE = getMessages().getText('card_form_action_delete_tooltip');
